import { render, staticRenderFns } from "./cyapss-testimonials.component.vue?vue&type=template&id=560ba70f"
import script from "./cyapss-testimonials.component.ts?vue&type=script&lang=ts&external"
export * from "./cyapss-testimonials.component.ts?vue&type=script&lang=ts&external"
import style0 from "./cyapss-testimonials.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports